module.exports = __webpack_public_path__ + "img/logocw.8ed2aca2.png";